import { Fragment } from 'react'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import MuiTableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import visuallyHidden from '@mui/utils/visuallyHidden'

const TableCell = styled(MuiTableCell)({
    padding: '5px 12px',
    fontSize: 12,
})

const TableText = styled(Typography)({
    fontSize: 12,
    fontWeight: 500,
})

const ChannelIconImg = styled('img')({
    display: 'inline',
    pr: 4,
    height: 20,
    mr: 2,
})

const COLUMNS = [
    {
        id: 'checkbox',
        align: 'left',
        label: <span style={visuallyHidden}>{gettext('Checkbox')}</span>,
        sort: false,
        width: 70,
    },
    {
        id: 'image',
        align: 'left',
        label: <span style={visuallyHidden}>{gettext('Image')}</span>,
        sort: false,
        width: 100,
    },
    {
        id: 'name',
        align: 'left',
        label: gettext('Name'),
        sort: false,
        width: 280,
    },
    {
        id: 'stock_unit',
        align: 'left',
        label: gettext('Stock unit'),
        sort: true,
        width: 140,
    },
    {
        id: 'percent_discount',
        align: 'left',
        label: gettext('% discount'),
        sort: true,
        width: 100,
    },
    {
        id: 'value_discount',
        align: 'left',
        label: gettext('discount'),
        sort: true,
        width: 100,
    },
] as const

export default function DiscountTableHead(props: {
    shops: Array<{
        id: number
        shop_name: string
        channel: { channel_square_icon_url: string }
    }>
    numSelected: number
    rowCount: number
    onSelectAllClick: (checked: boolean) => void
}) {
    const productInfoColumns = COLUMNS.slice(0, -2)

    return (
        <TableHead
            sx={{
                borderTop: (theme) => '1px solid ' + theme.palette.grey[200],
            }}
        >
            <TableRow>
                {productInfoColumns.map(({ width }, index) => (
                    <TableCell key={index} width={width} />
                ))}
                <MuiTableCell
                    colSpan={2}
                    width={200}
                    sx={{
                        borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <TableText>{gettext('Set all')}</TableText>
                </MuiTableCell>
                {props.shops.map((shop) => (
                    <TableCell
                        align="center"
                        key={shop.id}
                        colSpan={2}
                        sx={{ borderLeft: (theme) => `1px solid ${theme.palette.divider}` }}
                        width={150}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ChannelIconImg src={shop.channel.channel_square_icon_url} />
                            <TableText align="center">{shop.shop_name}</TableText>
                        </Box>
                    </TableCell>
                ))}
            </TableRow>
            <TableRow>
                {COLUMNS.map((column) => {
                    return (
                        <TableCell key={column.id} align={column.align} width={column.width}>
                            {column.id === 'checkbox' ? (
                                <Checkbox
                                    indeterminate={
                                        props.numSelected > 0 && props.numSelected < props.rowCount
                                    }
                                    checked={
                                        props.rowCount !== 0 && props.numSelected === props.rowCount
                                    }
                                    onChange={(_, checked) => props.onSelectAllClick(checked)}
                                />
                            ) : (
                                column.label
                            )}
                        </TableCell>
                    )
                })}
                {props.shops.map((shop) => {
                    return (
                        <Fragment key={shop.id}>
                            <TableCell
                                align="left"
                                sx={{ borderLeft: (theme) => `1px solid ${theme.palette.divider}` }}
                                width={75}
                            >
                                {gettext('Price')}
                            </TableCell>
                            <TableCell align="left" width={75}>
                                {gettext('Discount price')}
                            </TableCell>
                        </Fragment>
                    )
                })}
            </TableRow>
        </TableHead>
    )
}
